import MainHeader from '~/components/Organisms/MainHeader/MainHeader.vue'

export default {
  components: {
    MainHeader,
  },

  props: {
    propBus: {
      type: Object,
      required: true,
    },
  },

  computed: {
    currentLanguage() {
      return this.$i18n.locale
    },

    infoCardsComponent() {
      return this.currentLanguage === 'en' ? 'hot-info-cards' : null
    },

    instagramComponent() {
      return this.currentLanguage === 'en' ? 'hot-instagram' : null
    },

    socialProofComponent() {
      return this.currentLanguage === 'es-es' ? 'hot-social-proof' : null
    },

    sparkleComponent() {
      return this.currentLanguage === 'es-es' ? 'hot-sparkle' : null
    },

    hotmartCampComponent() {
      return this.currentLanguage === 'es-es' ? 'hot-hotmart-camp' : null
    },
  },
}
